import { MARKET_OPTIONS } from '../constants';
import type { MarketRecord } from '../types';

export function hasSelectedColoradoMarket(markets: readonly MarketRecord[]): boolean {
  return markets.some(market => market.selected && (
    market.code?.trim().toUpperCase() === 'CO' || market.name.trim().toUpperCase() === 'COLORADO'
  ));
}

export const PRODUCT_CATEGORIES = ['Flower', 'Edible', 'Vape', 'Topical'];
export const PRODUCT_FALLBACK_BRANDS = [];

export function getBrandOptions(brandMarketsMap) {
  const keys = Object.keys(brandMarketsMap || {});
  return keys.length ? keys : PRODUCT_FALLBACK_BRANDS;
}

export function getAllowedMarkets(brand, brandMarketsMap) {
  if (brand && brandMarketsMap && brandMarketsMap[brand]?.length) return brandMarketsMap[brand];
  return MARKET_OPTIONS;
}

export function getInitialMarkets(product, brandMarketsMap) {
  const allowed = getAllowedMarkets(product.brand, brandMarketsMap);
  const initialMarkets = product.markets && product.markets.length
    ? product.markets
    : product.market
      ? [product.market]
      : [];
  const filtered = initialMarkets.filter((m) => allowed.includes(m));
  return filtered.length ? filtered : [...allowed];
}

export function applyBrandChange(value, brandMarketsMap, setForm) {
  const nextAllowed = getAllowedMarkets(value, brandMarketsMap);
  setForm((f) => ({ ...f, brand: value, markets: [...nextAllowed] }));
}

export function getProductMarkets(product) {
  if (!product) return [];
  if (Array.isArray(product.markets) && product.markets.length) {
    return product.markets
      .map((market) => {
        if (typeof market === 'string') return market;
        return market?.name || market?.label || market?.abbreviation || '';
      })
      .filter(Boolean);
  }
  if (product.market) return [String(product.market)];
  return [];
}
